import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { Certification } from '../types';

interface CertificationCardProps {
  certification: Certification;
}

const CertificationCard = ({ certification }: CertificationCardProps) => {
  return (
    <div className="bg-surface rounded-lg border border-border hover:border-primary/50 transition-all duration-300 overflow-hidden group">
      <div className="relative h-48 overflow-hidden bg-muted">
        <Image
          src={certification.image}
          alt={certification.alt}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
        />
        <div className="absolute top-4 right-4 w-10 h-10 bg-background/90 backdrop-blur-sm rounded-full flex items-center justify-center">
          <Icon name={certification.icon} size={20} color="var(--color-primary)" />
        </div>
      </div>

      <div className="p-6">
        <h3 className="text-lg font-semibold text-foreground mb-2">{certification.name}</h3>
        <p className="text-sm text-muted-foreground mb-4">{certification.issuer}</p>

        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Calendar" size={16} />
            <span>{certification.date}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-primary">
            <Icon name="Award" size={16} />
            <span>Verified</span>
          </div>
        </div>

        <div className="mt-4 p-3 bg-muted rounded-md">
          <p className="text-xs text-muted-foreground mb-1">Credential ID</p>
          <p className="text-sm font-mono text-foreground">{certification.credentialId}</p>
        </div>
      </div>
    </div>
  );
};

export default CertificationCard;